import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import { createDeliveries } from '../redux/dataAnalyticsActions'
import CreatedDelivery from './CreatedDelivery'
import NewDelivery from './NewDelivery'
import { swalError, swalSuccess } from '../../../common/components/Swaler'
import { updateSwrCache } from '../../../common/utils'

const NewDeliveries = () => {
  const [newDeliveries, setNewDeliveries] = useState([])

  const dispatch = useDispatch()

  const addDelivery = (delivery) => {
    if (newDeliveries.some((d) => d.delivery.packageId === delivery.packageId)) return swalError('Dubletter', `${delivery.delivery.packageId} finns redan i listan`)

    setNewDeliveries(newDeliveries.concat(delivery))
  }

  const removeDelivery = (id) => {
    setNewDeliveries(newDeliveries.filter((d) => d.delivery.packageId !== id))
  }

  const send = async () => {
    dispatch(createDeliveries(newDeliveries))

    setTimeout(() => {
      swalSuccess('Leveranser skapade!', '', 'OK')
      setNewDeliveries([])
      updateSwrCache('/subject/admin/deliveries?', (p) => p, true)
    }, 2000)
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <NewDelivery addDelivery={addDelivery} />
        </Col>
      </Row>
      <br />
      <a href="https://share.vidyard.com/watch/QNu1ebp9CdYMXPpnfxsNYQ" target="_blank" rel="noopener">
        Hur man lägger till en testleverans
      </a>
      <br />
      <Row>
        <Col xs={12} md={12} lg={12}>
          <div style={{ backgroundColor: 'white', border: '1px solid rgba(0,0,0,0.1)', padding: 20 }}>
            {!newDeliveries.length ? 'Tomt' : null}

            {newDeliveries.map((delivery, i) => (
              <CreatedDelivery key={i} delivery={delivery} removeDelivery={removeDelivery} />
            ))}
            <hr />
            <div className="qSaveButton" onClick={send}>
              Skicka
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  )
}

export default NewDeliveries
